import { render, staticRenderFns } from "./ProfilePlaceholder.vue?vue&type=template&id=37db581d&"
import script from "./ProfilePlaceholder.vue?vue&type=script&lang=ts&"
export * from "./ProfilePlaceholder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports